import { connect } from 'react-redux';
import { Creators } from '../../../services/redux/auth/actions';
import StepSixComponent from './components';

const mapStateToProps = state => {
  const { isloading, error, user, error_message } = state.auth;
  return {
    isloading,
    error,
    error_message,
    user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loginUser: (vignet_number, pin) => {
      dispatch(Creators.loginRequest(vignet_number, pin));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StepSixComponent);

